import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { AuthForm } from '../components/AuthForm';

export default function AuthPage() {
  const { user, loading } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || '/dashboard';
  const [initialMode] = useState(location.state?.mode || 'signin');

  useEffect(() => {
    if (!loading && user) navigate(from, { replace: true });
  }, [user, loading, navigate, from]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-28" style={{ background: '#050505' }} data-testid="auth-page">
      <motion.div
        className="w-full max-w-md rounded-3xl border border-white/10 p-8 md:p-10"
        style={{ background: 'radial-gradient(ellipse at 50% -20%, rgba(226,193,121,0.1) 0%, #0a0a0a 60%)' }}
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="text-center mb-8">
          <img src="/cexus-logo.png" alt="CEXUS" className="w-12 h-12 mx-auto mb-5 object-contain" style={{ filter: 'brightness(1.9)' }} />
          <p className="accent-tag !mb-3 justify-center flex">{t('authTagline')}</p>
          <h1 className="text-2xl font-bold text-white" style={{ fontFamily: "'Syne', sans-serif" }} data-testid="auth-page-title">
            {t('authWelcomeTitle')}
          </h1>
          <p className="mt-2 text-sm text-gray-400">{t('authWelcomeText')}</p>
        </div>
        <AuthForm
          initialMode={initialMode}
          onSuccess={(u, mode) => navigate(from, { replace: true, state: { justRegistered: mode === 'signup' } })}
        />
      </motion.div>
    </div>
  );
}
